<template>
    <b-card no-body>
        <UpdateRoleAccessModal :update_role_access.sync="modals.update_role_access" v-on:closeModal="closeModal()" :role_item="role_item" :available_group_access="available_group_access" />
        <DetailRoleAccessModal :detail_role_access.sync="modals.detail_role_access" v-on:closeModal="closeModal()" :role_item="role_item" :available_group_access="available_group_access" />
        <!-- HEADER -->
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>

         <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                    height="500"
                ></el-table-column>
    
                <!-- ROLE NAME COLUMN -->
                <el-table-column
                    prop="role_name"
                    label="Role Name"
                    sortable
                >
                    <template slot-scope="scope">
                        <a href="javascript:void(0)" :class=" scope.row.is_can_change ? 'mb-0 text-primary font-weight-bold' : 'mb-0 text-dark'" @click="detailRoleAccess(scope.row)">
                            {{ scope.row.role_name }}
												</a>
												<small v-if="!scope.row.is_can_change" class="d-block">General Role</small>
                    </template>
                </el-table-column>
                
                <!-- ROLE TYPE COLUMN -->
                <el-table-column
                prop="role_type"
                label="Role Type"
                sortable
                >
                <template slot-scope="scope">
                    <p class="text-capitalize">{{ scope.row.role_type }}</p>
                </template>
                </el-table-column>

                <!-- TOTAL ACCESS COLUMN -->
                <el-table-column
                prop="role_access"
                label="Total Access"
                sortable
                >
                <template slot-scope="scope">
                    <p class="">{{ scope.row.role_access.length }} Access</p>
                </template>
                </el-table-column>

								<!-- TOTAL USER USED -->
                <el-table-column
                prop="total_used"
                label="Total User Use"
                sortable
                >
                <template slot-scope="scope">
                    <p class="">{{ scope.row.total_used}} User</p>
                </template>
                </el-table-column>

                <!-- STATUS CREATED BY COLUMN -->
                <!-- <el-table-column
                    prop="created_by"
                    label="Created By"
                    sortable    
                >
                </el-table-column> -->

                <!-- STATUS CREATED AT COLUMN -->
                <!-- <el-table-column
                    prop="created_at"
                    label="Date Created"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                    
                </el-table-column> -->

                <!-- STATUS ACTIONS COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.role_id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editRoleAccess(scope.row)" v-if="scope.row.is_can_change">
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="duplicateRoleAccess(scope.row)">
                                    Duplicate
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteRoleAccess(scope.row.role_id)" v-if="scope.row.is_can_change">
                                    Delete
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import mainEventBus from '@/assets/js/mainEventBus'
import { mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import UpdateRoleAccessModal from '@/views/Configurations/RoleAccessSettings/RoleAccessModals/UpdateRoleAccessModal'
import DetailRoleAccessModal from '@/views/Configurations/RoleAccessSettings/RoleAccessModals/DetailRoleAccessModal'

import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        UpdateRoleAccessModal,
				DetailRoleAccessModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
		props: {
			available_group_access: Array
		},
    data() {
        return {
            modals: {
                update_role_access: false,
                detail_role_access: false,
            },
            isTableLoading: true,
            propsToSearch:['role_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            role_item: {},
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
        }
    },
    created(){
        this.getRoleAccess()
    },  
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);

        mainEventBus.$on('refresh-status', this.getRoleAccess)
    },
    beforeUnmount() {
        mainEventBus.$off('refresh-status', this.getRoleAccess)
    },
		computed:{
      ...mapState(useAuthStore, ['auth_user'])
    },
    methods: {
				selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getRoleAccess(){
            this.isTableLoading = true
            axios.get(services.access_control + 'role', {headers: getHeader()})
            .then(res => {
								this.tableData = res.data.data
                this.isTableLoading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        duplicateRoleAccess(item){
					swal.fire({
                title: 'Confirmation',
                text: "Do you want to create a new role based on this role ?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, duplicate it!'
            }).then((result) => {
                if (result.isConfirmed) {
									let form = new FormData()
									form.append('role_name', item.role_name + " (copy)")
									form.append('role_type', item.role_type)
									form.append('role_description', item.role_description)
									form.append('role_access', item.role_access)

									axios.post(services.access_control + 'role', form, { headers: getHeader() })
										.then(res => {
											editRoleAccess(res);
										})
										.catch(e => {
											
										})
                }
            })
        },
        editRoleAccess(item){
            this.role_item = item
            this.modals.update_role_access = true;
        },
        detailRoleAccess(item){
            this.role_item = item
            this.modals.detail_role_access = true;
        },
        deleteRoleAccess(role_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.access_control + 'role/' + role_id, {headers: getHeader()})
                    .then(res => {
                            this.getRoleAccess();
                            this.notifySuccess('<b>Role Access: </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                }
            })
        },
        closeModal(){
					this.getRoleAccess();
          this.modals.update_role_access = false;
          this.modals.detail_role_access = false;
        },
    }
}
</script>